export default {"src":"/_next/static/media/arrow-up.f1f1cecb.svg","height":21,"width":9};